import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { __, blueZodiac, cornflower, grey, pastelGreen } from '@web/birdz-angular';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'app-cell-state',
  imports: [MatTooltip, MatIconModule],
  templateUrl: './cell-state.component.html',
  styleUrl: './cell-state.component.scss',
})
export class CellStateComponent {
  color = '';
  tooltip = '';

  constructor() {}

  agInit(params: ICellRendererParams) {
    if (params.value === 'OK') {
      this.color = pastelGreen;
      this.tooltip = __('FUNCTIONAL');
    } else if (params.value === 'NC') {
      this.color = blueZodiac;
      this.tooltip = __('PRESUMED_NON_COMMUNICATING');
    } else if (params.value === 'HS') {
      this.color = cornflower;
      this.tooltip = __('PRESUMED_OUT_OF_SERVICE');
    } else {
      this.color = grey;
      this.tooltip = __('UNKNOWN');
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
